import { useEffect, useState } from "react";
import api from "@/lib/api";

export const usePublicLoyalty = () => {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/public/loyalty-config")
      .then((response) => setConfig(response.data))
      .catch(() => setConfig(null))
      .finally(() => setLoading(false));
  }, []);

  return { config, loading };
};